import type { Permiso } from '@cmms/shared';

/**
 * Permiso que hace falta para abrir cada ruta del router (ver `app.tsx`).
 * Una ruta sin entrada aquí no exige permiso en el front; el backend sigue
 * validando cada petición. Las entradas más específicas van antes.
 */
const PERMISO_POR_PREFIJO: [prefijo: string, permiso: Permiso][] = [
  ['/ordenes/nueva', 'ot:crear'],
  ['/ordenes', 'ot:leer'],
  ['/activos', 'activo:leer'],
  ['/ubicaciones', 'ubicacion:leer'],
  ['/partes', 'parte:leer'],
  ['/reposicion', 'parte:leer'],
  ['/procedimientos', 'procedimiento:leer'],
  ['/ejecuciones', 'procedimiento:ejecutar'],
  ['/medidores', 'medidor:leer'],
  ['/tipos-falla', 'tipo_falla:leer'],
  ['/usuarios', 'usuario:leer'],
  ['/catalogos', 'catalogo:administrar'],
  ['/reportes', 'reporte:leer'],
  ['/actividad', 'auditoria:leer'],
  ['/licencia', 'licencia:leer'],
  ['/gestion', 'app_version:gestionar'],
];

/** Permiso requerido para abrir `ruta`, o `null` si la ruta no exige ninguno en el front. */
export function permisoDeRuta(ruta: string): Permiso | null {
  const limpia = ruta.split('?')[0]!;
  if (/\/ordenes\/[^/]+\/editar$/.test(limpia)) return 'ot:editar';
  const entrada = PERMISO_POR_PREFIJO.find(([prefijo]) => limpia === prefijo || limpia.startsWith(`${prefijo}/`));
  return entrada ? entrada[1] : null;
}
